import { setup } from 'xstate';

export type LeadSubmissionState = 'projectDetails' | 'storeInformation' | 'auth' | 'success';

export type LeadSubmissionEvent = 
    | { type: 'NEXT' } 
    | { type: 'BACK' } 
    | { type: 'SUBMIT' }
    | { type: 'SKIP_TO_SUCCESS' };  // New event for authenticated users

export const leadSubmissionMachine = setup({
    types: {
        events: {} as LeadSubmissionEvent,
    }
}).createMachine(
    {
        id: 'leadSubmissionForm',
        initial: 'projectDetails',

        states: {
            projectDetails: {
                on: {
                    NEXT: {
                        target: 'storeInformation',
                    },
                },
            },
            storeInformation: {
                on: {
                    // NEXT goes to auth step (for unauthenticated users)
                    NEXT: {
                        target: 'auth',
                    },
                    // SKIP_TO_SUCCESS for authenticated users
                    SKIP_TO_SUCCESS: {
                        target: 'success',
                    },
                    BACK: {
                        target: 'projectDetails',
                    },
                },
            },
            auth: {
                on: {
                    BACK: {
                        target: 'storeInformation',
                    },
                    SUBMIT: {
                        target: 'success',
                    },
                },
            },
            success: {
                type: 'final',
            },
        },
    }
);